module.exports = __webpack_public_path__ + "static/media/lon_acc_att.2461c7f4.png";